// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function gapValue(gap) {
  if (gap === 2) {
    return "0.5rem";
  } else if (gap === 3) {
    return "0.75rem";
  } else if (gap === 4) {
    return "1rem";
  } else if (gap === 5) {
    return "1.25rem";
  } else if (gap === 6) {
    return "1.5rem";
  } else if (gap === 8) {
    return "2rem";
  } else {
    return "0.25rem";
  }
}

function alignValue(align) {
  if (align === "end") {
    return "flex-end";
  } else if (align === "start") {
    return "flex-start";
  } else if (align === "center") {
    return "center";
  } else {
    return "stretch";
  }
}

function justifyValue(justify) {
  if (justify === "end") {
    return "flex-end";
  } else if (justify === "start") {
    return "flex-start";
  } else if (justify === "center") {
    return "center";
  } else {
    return "space-between";
  }
}

function Stack$Stack(props) {
  let __className = props.className;
  let __wrap = props.wrap;
  let __justify = props.justify;
  let __align = props.align;
  let __gap = props.gap;
  let __direction = props.direction;
  let direction = __direction !== undefined ? __direction : "vertical";
  let gap = __gap !== undefined ? __gap : 4;
  let align = __align !== undefined ? __align : "stretch";
  let justify = __justify !== undefined ? __justify : "start";
  let wrap = __wrap !== undefined ? __wrap : false;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: Emotion.Css.cx([
      Emotion.Css.css({
        display: "flex",
        flexDirection: direction === "horizontal" ? "row" : "column",
        gap: gapValue(gap),
        alignItems: alignValue(align),
        justifyContent: justifyValue(justify),
        flexWrap: wrap ? "wrap" : "nowrap"
      }),
      className
    ])
  });
}

let Stack = {
  gapValue: gapValue,
  alignValue: alignValue,
  justifyValue: justifyValue,
  make: Stack$Stack
};

export {
  Stack,
}
/* Emotion Not a pure module */
